import * as React from 'react';

import { Button, Label, Alert } from 'reactstrap';
import { AvForm, AvField, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Link } from 'react-router-dom';

export interface ISignInPanelProps {
  loginError: boolean;
  handleLogin: Function;
}

export class SignInPanel extends React.Component<ISignInPanelProps> {
  handleSubmit = (event, { username, password, rememberMe }) => {
    this.props.handleLogin(username, password, rememberMe);
  };

  render() {
    return (
      <section className="sign-in-panel" aria-labelledby="login-title">
        <h2 id="login-title">Sign in</h2>
        {this.props.loginError ? (
          <Alert color="danger">
            <strong>Sign in failed.</strong> Check your username and password, then try again.
          </Alert>
        ) : null}
        <AvForm onValidSubmit={this.handleSubmit}>
          <AvField name="username" label="Username" placeholder="Your username" required errorMessage="Enter your username." />
          <AvField
            name="password"
            type="password"
            label="Password"
            placeholder="Your password"
            required
            errorMessage="Enter your password."
          />
          <AvGroup check inline>
            <Label className="form-check-label">
              <AvInput type="checkbox" name="rememberMe" /> Remember me
            </Label>
          </AvGroup>
          <Button type="submit" className="sign-in-submit" block>
            Sign in
          </Button>
        </AvForm>
        <p className="sign-in-register">
          New here? <Link to="/register">Register a new account</Link>
        </p>
      </section>
    );
  }
}

export default SignInPanel;
